import dayjs from 'dayjs';
import { IProductFilter } from '@/models/products.model';

export const getSortedProductFilters = (filters: IProductFilter[]) => {
  return [...filters].sort((a, b) => {
    if (a?.position !== b?.position) {
      return (a?.position ?? 0) - (b?.position ?? 0);
    }
    return dayjs(b?.updated_at).valueOf() - dayjs(a?.updated_at).valueOf();
  });
};
